export default __webpack_public_path__ + "static/texture-yellow-dots-04-324eafe4446084555d3f89a83cd33d5d.png";